import script from "./JobStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./JobStudent.vue?vue&type=script&setup=true&lang=js"

import "./JobStudent.vue?vue&type=style&index=0&id=60adea40&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60adea40"]])

export default __exports__